<template>
  <zone-editor></zone-editor>
</template>

<script>
import ZoneEditor from './editor'

export default {
  name: 'PageZones',
  components: {
    ZoneEditor,
  },
}
</script>
